import { render, staticRenderFns } from "./SendDocumentTable.vue?vue&type=template&id=79e262dd&scoped=true&lang=pug"
import script from "./SendDocumentTable.vue?vue&type=script&lang=ts"
export * from "./SendDocumentTable.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentTable.vue?vue&type=style&index=0&id=79e262dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e262dd",
  null
  
)

export default component.exports